import React, { useContext } from 'react';
import mainStyle from '../../ContexteCreationStyle';
import style from './style';
import {FormGroup, FormLabel, Grid, TextField} from "@mui/material";
import i18next from "i18next";
import {Controller, useFormContext} from "react-hook-form";
import clsx from "clsx";
import { isContextModelNameAvailable } from '../../../../../../services/edge/ContexteService';
import { Context } from '../../../../../../states/Store';


export const ContextCreationConfigRight = () => {
  const {classes: mainStyleClasses} = mainStyle();
  const {classes} = style();
  const [state, dispatch] = useContext(Context);

  const {
    control,
    formState: {errors},
  } = useFormContext();

  return <div>
    <h2 className={mainStyleClasses.rightMainTitle}>
      {i18next.t("demandes.contextModel.creationForm.config.title")}
    </h2>
    <div className={mainStyleClasses.rightContent}>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <div className={clsx(mainStyleClasses.inputWrapper, classes.item)}>
            <FormLabel className={mainStyleClasses.formLabel}>
              {`${i18next.t("demandes.contextModel.creationForm.config.label")} * `}
            </FormLabel>
            <FormGroup>
              <Controller
                control={control}
                name="name"
                rules={{
                  required: i18next.t("infos.required"),
                  validate: async (value) => {
                    if (value.length > 100) {
                      return i18next.t("demandes.contextModel.creationForm.config.labelLengthError")
                    }
                    const isNameAvailable = await isContextModelNameAvailable(state.account.id, value, dispatch);
                    if(!isNameAvailable) {
                      return i18next.t("demandes.contextModel.creationForm.config.nameError")
                    }
                    return true;
                  },
                }}
                render={({field}) => (
                  <TextField
                    id="name"
                    className={clsx(mainStyleClasses.textField)}
                    placeholder={i18next.t("demandes.contextModel.creationForm.config.placeholder.modelLabel")}
                    variant="outlined"
                    error={!!errors.name}
                    helperText={errors.name?.message}
                    fullWidth
                    {...field}
                  />
                )}
              />

            </FormGroup>
          </div>
        </Grid>
        <Grid item xs={6}>
          <div className={clsx(mainStyleClasses.inputWrapper, classes.item)}>
            <FormLabel className={mainStyleClasses.formLabel}>
              {`${i18next.t("demandes.contextModel.creationForm.config.code")} * `}
            </FormLabel>
            <FormGroup>
              <Controller
                control={control}
                name="code"
                rules={{
                  required: i18next.t("infos.required"),
                  validate: (value) => {
                    if (value.length > 100) {
                      return i18next.t("demandes.contextModel.creationForm.config.labelLengthError")
                    }
                    return true;
                  },
                }}
                render={({field}) => (
                  <TextField
                    id="code"
                    className={clsx(mainStyleClasses.textField)}
                    placeholder={i18next.t("demandes.contextModel.creationForm.config.placeholder.code")}
                    variant="outlined"
                    error={!!errors.code}
                    helperText={errors.code?.message}
                    fullWidth
                    {...field}
                  />
                )}
              />

            </FormGroup>
          </div>
        </Grid>
        <Grid item xs={12}>

          <div className={clsx(mainStyleClasses.textInputWrapper, classes.item)}>
            <FormLabel className={mainStyleClasses.formLabel}>
              {`${i18next.t("demandes.contextModel.creationForm.config.description")}`}
            </FormLabel>
            <FormGroup>
              <Controller
                control={control}
                name="description"
                rules={{
                  validate: (value) => {
                    if (value && value.length > 1000) {
                      return i18next.t("demandes.contextModel.creationForm.config.descriptionHelp")
                    }
                    return true;
                  },
                }}
                render={({field}) => (
                  <TextField
                    id="description"
                    multiline
                    rows={4}
                    className={clsx(mainStyleClasses.textField)}
                    placeholder={i18next.t("demandes.contextModel.creationForm.config.placeholder.modelDescription")}
                    variant="outlined"
                    error={!!errors.description}
                    helperText={errors.description?.message}
                    fullWidth
                    {...field}
                  />
                )}
              />
              <p className={classes.inputHelper}>{i18next.t("demandes.contextModel.creationForm.config.descriptionHelp")}</p>
            </FormGroup>

          </div>
        </Grid>
      </Grid>
    </div>
  </div>
}

